import { createStoreError } from '@atlassian/conversation-assistant/controllers/chat-store/utils';

import type { ThinkingErrorTemplate } from '../../pm-plugins/thinking-plugin';

const KNOWN_TEMPLATES: ReadonlySet<string> = new Set<ThinkingErrorTemplate>([
	'RATE_LIMIT',
	'ACCEPTABLE_USE_VIOLATIONS',
	'TOKEN_LIMIT_EXCEEDED',
]);

// Raw ERROR frame passed to promptStreamHook.onError (a StreamError, not an Error instance).
type StreamErrorFrame = {
	message?: {
		message_template?: string;
		status_code?: number;
	};
};

// Reads the raw StreamError frame directly (onError's input); other inputs go through ai-mate's
// createStoreError (shared with Rovo inline chat) to stay in lockstep for thrown error classes.
const extractErrorFields = (
	error: unknown,
): { message_template?: string; status_code?: number } => {
	const frameMessage = (error as StreamErrorFrame | null | undefined)?.message;
	if (frameMessage && (frameMessage.message_template || frameMessage.status_code !== undefined)) {
		return {
			message_template: frameMessage.message_template,
			status_code: frameMessage.status_code,
		};
	}

	const { message_template, status_code } = createStoreError(error);
	return { message_template, status_code };
};

// Recognised message_template wins, else 429 -> RATE_LIMIT, else UNKNOWN.
export const mapStreamErrorToTemplate = (error: unknown): ThinkingErrorTemplate => {
	const { message_template, status_code } = extractErrorFields(error);

	if (message_template && KNOWN_TEMPLATES.has(message_template)) {
		return message_template as ThinkingErrorTemplate;
	}

	if (status_code === 429) {
		return 'RATE_LIMIT';
	}

	return 'UNKNOWN';
};
